import React, { useEffect, useState } from 'react'
import { CustomerAddressRow, OrderItems, SideBackNav } from '../../../../components/organisms';
import { OrderInProgressDetailRow } from './OrderInProgressDetailRow';
import { useLocation } from 'react-router';
import { getOrderItems } from '../../../../utils';

export const OrderDetailsComp = ({ onBack }) => {
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const { state } = useLocation();
    const { orderId, customer, time, date, orderNumber, url, value, customerAddress, note, lineItems } = state;
    const orderValue = value.toLocaleString({ maximumFractionDigits: 2 });

    useEffect(async () => {
        setIsLoading(true)
        // const {itemsAndLinks: res} = await getOrderItems(orderId);
        // const inprogressItems = res?.filter(item => item.status === 1);
        setData(lineItems);
        setIsLoading(false);
    }, []);
    
    return (
        <div className='new-orders-screen'>
            <div className="dashboard-content-post body" style={{marginLeft:'0px'}}>
                <SideBackNav
                    title={'Back'}
                    onClick={onBack}
                    orderNumber={`Order ${orderNumber}`}
                    statusTitle={'In Progress Order'}
                    ifNotes
                    notes={note}
                    isView={note ? true : false}
                />
            </div>
            <div className="details-overlay">
                <div className='new-orders-container' id="details-screen-box">
                    <div className='orders'>
                        <OrderInProgressDetailRow
                            customerName={customer || 'N/A'}
                            time={time}
                            orderDate={date}
                            orderValue={orderValue}
                            productUrl={url}
                            orderRef={orderNumber}
                        />
                    </div >
                </div>
                <div className="top-space-details">
                    <div className='new-orders-container' id="details-screen-box">
                        <div className='orders'>
                            <CustomerAddressRow
                                customerContactNo={customerAddress?.phone || 'N/A'}
                                address1={customerAddress?.address1 || "N/A"}
                                address2={customerAddress?.address2 || "N/A"}
                                postalCode={customerAddress?.zip || "N/A"}
                                city={customerAddress?.city || "N/A"}
                                country={customerAddress?.country || "N/A"}
                            />
                        </div >
                    </div>
                </div>
                <OrderItems data={data} isLoading={isLoading}/>
            </div>
        </div>
    )
}
